import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/views/Home/Index'
import HomeProduct from '@/views/Home/Product'
import HomeApp from '@/views/System/Application/App'
import HomeAccount from '@/views/System/Application/Account'
import HomeApply from '@/views/System/Application/Apply'
import SpendIndex from '@/views/Spend/Index'
import SpendChannel from '@/views/Spend/Channel'
import SpendAnalysis from '@/views/Spend/Analysis/Index'
import SpendCheck from '@/views/Spend/Check/Index'
import SpendCheckAgent from '@/views/Spend/Check/Agent'
import SpendSelf from '@/views/Spend/Self/Index'
import SpendRebate from '@/views/Spend/Rebate/Index'
import SpendRebateConfig from '@/views/Spend/Rebate/Config'
import RevenueIndex from '@/views/Revenue/Index'
import RevenueAnalysis from '@/views/Revenue/Analysis/Index'
import RevenueCheck from '@/views/Revenue/Check/Index'
import RevenueCheckChannel from '@/views/Revenue/Check/Channel'
import RevenueSelf from '@/views/Revenue/Self/Index'
import Login from '@/views/Login'
import ErrorPage from '@/views/ErrorPage'

import AnalysisIndex from '@/views/Analysis/Index'
import AnalysisList from '@/views/Analysis/List'

import ReportList from '@/views/Report/List'
import ReportIndex from '@/views/Report/Index'
import ReportAdd from '@/views/Report/Add'
import ReportDictionaries from '@/views/Report/Dictionaries'
import ReportDictionariesAuth from '@/views/Report/DictionariesAuth'

import ErrorData from '@/views/ErrorData/Index'
import Message from '@/views/Message/Index'

import Settlement from '@/views/Settlement/Index'
import ExchangeRate from '@/views/ExchangeRate/Index'
import DataInfoNotice from '@/views/Home/DataInfoNotice'

import SystemMenu from '@/views/System/Menu/Menu'
import SystemGroup from '@/views/System/User/UserGroup'
import SystemRelation from '@/views/System/User/Relation'
import SystemOldgbMenu from '@/views/System/Menu/OldgbMenu'
import SystemUser from '@/views/System/User/User'

import SystemConfig from '@/views/System/Config/Config'
import SystemConfigType from '@/views/System/Config/Type'

import Purchase from '@/views/Purchase/Index'
import PurchaseCheck from '@/views/Purchase/Check'
import PurchaseCheckIos from '@/views/Purchase/Check/Ios'
import PurchaseCheckAndroid from '@/views/Purchase/Check/Android'
import PurchaseRatio from '@/views/Purchase/Ratio'


import ProductCheck from '@/views/Product/Check/Index'

import {GetBaseChannel, GetBaseCountry, GetLogin} from "../api/v1/base_info";

Vue.use(Router)

const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  // base: '/data_center',
  routes: [
    {
      path:'/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/',
      name: 'Home',
      component: HomeIndex
    },
    {
      path: '/product',
      name: 'Product',
      component: HomeProduct
    },
    {
      path: '/app',
      name: 'App',
      component: HomeApp
    },
    {
      path: '/account',
      name: 'Account',
      component: HomeAccount
    },
    {
      path: '/config',
      name: 'Config',
      component: SystemConfig
    },
    {
      path: '/config_type',
      name: 'ConfigType',
      component: SystemConfigType
    },
    {
      path: '/menu',
      name: 'Menu',
      component: SystemMenu
    },
    {
      path: '/oldgb_menu',
      name: 'OldgbMenu',
      component: SystemOldgbMenu
    },
    {
      path: '/user',
      name: 'User',
      component: SystemUser
    },
    {
      path: '/apply',
      name: 'Apply',
      component: HomeApply
    },
    {
      path: '/user_group',
      name: 'UserGroup',
      component: SystemGroup
    },
    {
      path: '/relation',
      name: 'relation',
      component: SystemRelation
    },
    {
      path: '/spend',
      name: 'Spend',
      component: SpendIndex
    },
    {
      path: '/spend_channel',
      name: 'SpendChannel',
      component: SpendChannel
    },
    {
      path: '/spend_analysis',
      name: 'SpendAnalysis',
      component: SpendAnalysis
    },
    {
      path: '/spend_check',
      name: 'SpendCheck',
      component: SpendCheck
    },
    {
      path: '/spend_check_agent',
      name: 'SpendCheckAgent',
      component: SpendCheckAgent
    },
    {
      path: '/spend_self',
      name: 'SpendSelf',
      component: SpendSelf
    },
    {
      path: '/spend_rebate',
      name: 'SpendRebate',
      component: SpendRebate
    },
    {
      path: '/spend_rebate/config',
      name: 'SpendRebateConfig',
      component: SpendRebateConfig
    },
    {
      path: '/revenue',
      name: 'Revenue',
      component: RevenueIndex
    },
    {
      path: '/revenue_check',
      name: 'RevenueCheck',
      component: RevenueCheck
    },
    {
      path: '/revenue_check_channel',
      name: 'RevenueCheckChannel',
      component: RevenueCheckChannel
    },
    {
      path: '/revenue_analysis',
      name: 'RevenueAnalysis',
      component: RevenueAnalysis
    },
    {
      path: '/revenue_self',
      name: 'RevenueSelf',
      component: RevenueSelf
    },
    {
      path: '/report',
      name: 'Report',
      component: ReportList
    },
    {
      path: '/analysis',
      name: 'Analysis',
      component: AnalysisIndex
    },
    {
      path: '/analysis_report',
      name: 'AnalysisList',
      component: AnalysisList
    },
    {
      path: '/report_add',
      name: 'ReportAdd',
      component: ReportAdd
    },
    {
      path: '/report_index',
      name: 'ReportIndex',
      component: ReportIndex
    },
    {
      path: '/report/dictionaries',
      name: 'ReportDictionaries',
      component: ReportDictionaries
    },
    {
      path: '/report/dictionaries_auth',
      name: 'ReportDictionariesAuth',
      component: ReportDictionariesAuth,
    },
    {
      path: '/error_data',
      name: 'ErrorData',
      component: ErrorData
    },
    {
      path: '/message',
      name: 'Message',
      component: Message
    },
    {
      path: '/settlement',
      name: 'Settlement',
      component: Settlement
    },
    {
      path: '/exchange_rate',
      name: 'ExchangeRate',
      component: ExchangeRate
    },
    {
      path: '/purchase',
      name: 'Purchase',
      component: Purchase
    },
    {
      path: '/purchase_check',
      name: 'PurchaseCheck',
      component: PurchaseCheck
    },
    {
      path: '/purchase_check_ios',
      name: 'PurchaseCheckIos',
      component: PurchaseCheckIos
    },
    {
      path: '/purchase_check_android',
      name: 'PurchaseCheckAndroid',
      component: PurchaseCheckAndroid
    },
    {
      path: '/purchase_ratio',
      name: 'PurchaseRatio',
      component: PurchaseRatio
    },
    {
      path: '/product/check',
      name: 'ProductCheck',
      component: ProductCheck
    },
    {
      path: '/data_info_notice',
      name: 'DataInfoNotice',
      component: DataInfoNotice
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorPage
    }
  ]
})

function _out_login(to,next){
  localStorage.setItem("user_id","")
  localStorage.setItem("user_token","")
  if (to.path==='/login'){
    next()
  }else{
    next("/login")
  }
}

function _login(to,next){
  if (to.path==='/login'){
    next("/")
  }else{
    next()
  }
}

router.beforeEach((to,from,next)=> {
  const that = router.app
  if (!!!to.query.app_id){
    to.query.app_id = localStorage.getItem("app_id")?localStorage.getItem("app_id"):0
    router.push({path:to.path,query:to.query})
    return
  }else{
    that.$store.commit("setAppId",to.query.app_id)
  }
  if (to.query.user_id&&to.query.user_token){
    localStorage.setItem("user_id",to.query.user_id)
    localStorage.setItem("user_token",to.query.user_token)
    let _query = JSON.parse(JSON.stringify(to.query))
    delete _query.user_id
    delete _query.user_token
    router.push({path:to.path,query:_query})
    return
  }
  if (that.$store.getters.getUserLogin){
    _login(to,next)
  }else{
    let _user_id = localStorage.getItem("user_id")
    let _user_token = localStorage.getItem("user_token")
    if (_user_id&&_user_token){
      GetLogin({user_id:_user_id,user_token:_user_token}).then(resp => {
        if (resp.code===200){
          that.$store.commit("setUserLogin",true)
          that.$store.commit("setUserInfo",resp.data)
          _login(to,next)
        }else{
          _out_login(to,next)
        }
      })
    }else{
      _out_login(to,next)
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js